/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Quantity_HarvestingInputs */

const vi_care_log_quantity_harvesting = /** @type {(inputs: Care_Log_Quantity_HarvestingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản lượng (kg)`)
};

/**

* @param {Care_Log_Quantity_HarvestingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_quantity_harvesting = /** @type {((inputs?: Care_Log_Quantity_HarvestingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Quantity_HarvestingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_quantity_harvesting(inputs)
});